import React from "react";

const TradingExperience = () => {
  return (
    <div className="bg-[#33d6ad] mx-[96px] w-[90%]  xxl:mx-auto xxl:w-[1248px] text-[#131623] lg:my-20 rounded-[20px] max-container py-16">
      <div className="max-w-6xl px-4 lg:px-0 mx-auto text-center">
        <h2 className="text-[28px] lg:text-5xl font-poppins font-semibold lg:mb-2">
          Boost Your Trading Success
        </h2>
        <p className="text-[28px] lg:text-5xl font-poppins font-semibold lg:mb-5">
          With NeoTrader
        </p>
        <p className="lg:text-xl text-base font-aileron text-[#000f3b] mb-4 lg:mb-8">
          Get Fast, Easy, Highly-Accurate Trading Signals & Readymade Trades!
        </p>
        <div className="flex justify-center items-center">
          <a
            href="https://neotrader.in/auth/webinar_register/duration%3Done_month/"
            target="_blank"
          >
            <button className="font-poppins hover:text-[#33D6AD] font-semibold text-[#17131e] hover:bg-[#17131e] transition-all bg-[#33D6AD] lg:px-[32px] px-7 border py-[10px] lg:py-[16px] rounded-[50px] border-[#17131e]">
              Subscribe Now
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TradingExperience;
